import React from 'react';
import { Stack, Loader, Text, theme } from '@veeqo/ui';
import { ContentStyle, copy } from 'components/Landing/content';
import { useTranslation } from 'context/TranslationContext';

export const Progress = ({
  loadingColor = 'white',
  contentStyle,
}: {
  loadingColor: string;
  contentStyle: ContentStyle;
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="vertical"
      style={{
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: theme.sizes.md,
        minHeight: '5.5rem',
      }}
    >
      <Loader type="TailSpin" color={loadingColor} height={40} width={40} />
      <Text
        variant="subheadingMedium"
        style={{
          marginTop: theme.sizes.md,
        }}
      >
        {t(copy[contentStyle].progressId)}
      </Text>
    </Stack>
  );
};
